module.exports = __webpack_public_path__ + "static/media/credit-card-active.1a626687.svg";